import { Injectable } from '@angular/core';
import { RestService } from '../rest.service';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { ErrorsService, CARREGAR, SALVAR, ATUALIZAR, ENVIAR } from '../errors/errors.service';
import { SolicitacaoVO } from 'src/app/entity/SolicitacaoVO';
import { URL_API } from 'src/app/tools/URL';
import { retry, catchError } from 'rxjs/operators';
import { AuthService } from '../autenticacao/auth.service';
import { MSG_OBG_TEMA, MSG_OBG_DESCRICAO } from 'src/app/tools/Mensagens';

@Injectable({
  providedIn: 'root'
})
export class SolicitacaoService {
  solicitacao = this.builder.group(this.preencherVo());

  constructor(
    private rest: RestService,
    private builder: FormBuilder,
    private errorsService: ErrorsService,
    private authService: AuthService) { }

    carregarDados() {
      return this.rest.get(`${URL_API.PATH_SOLICITACAO}/carregar`).pipe(
        retry(1),
        catchError(response => this.errorsService.handleError(response, CARREGAR))
      );
    }

    carregarDadosService() {

      this.carregarDados().subscribe(retorno => {
        this.solicitacao.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.solicitacao.controls.listaCartorio.setValue(retorno.listaCartorio);
        this.solicitacao.controls.listaTipoProcessoCompleta.setValue(retorno.listaTipoProcessoCompleta);
        this.solicitacao.controls.listaSistemasCompleta.setValue(retorno.listaSistemasCompleta);
        this.solicitacao.controls.assuntos.setValue(retorno.assuntos);
      });

    }

    carregarPorId(id: number) {

      return this.rest.get(`${URL_API.PATH_SOLICITACAO + '/' + id}`);

    }

    gravarManifestoOperador(manifestante, arquivos = [], isEnviar) {

      this.solicitacao.controls.nome.setValue(manifestante.nome);
      this.solicitacao.controls.email.setValue(manifestante.email);
      this.solicitacao.controls.username.setValue(this.authService.usuarioLogado.username);

      if (this.solicitacao.value.tipoDeJustica !== '1' && this.solicitacao.value.tipoDeJustica !== '2') {

        this.solicitacao.value.tipoDeJustica = null;

      }

      this.solicitacao.controls.files.setValue([]);
      arquivos.forEach((value, key) => {
        this.solicitacao.value.files.push({
          nomeArquivo: key,
          conteudo: value
        });
      });

      return isEnviar ? this.enviar(this.solicitacao.getRawValue()) : this.salvar(this.solicitacao.getRawValue());

    }

    salvar(obj) {
      if (obj.id == null) {
        return this.gravar(obj);
      } else {
        return this.atualizar(obj);
      }
    }

    public enviar(obj) {
      return this.rest.post(`${URL_API.PATH_SOLICITACAO}/enviar`, obj).pipe(
        catchError(response => this.errorsService.handleError(response, ENVIAR))
      );
    }

    // private gravar(obj: SolicitacaoVO) {
    //   return this.rest.post(`${URL_API.PATH_SOLICITACAO}/salvar`, obj).pipe(
    //     catchError(response => this.errorsService.handleError(response, SALVAR))
    //   );
    // }

    gravar(obj) {
      return this.rest.post(`${URL_API.PATH_SOLICITACAO}/salvar`, obj);
    }

    private atualizar(obj) {
      return this.rest.put(`${URL_API.PATH_SOLICITACAO}/salvar/${obj.id}`, obj).pipe(
        catchError(response => this.errorsService.handleError(response, ATUALIZAR))
      );
    }

    buscarProcesso() {

      const numeroProcesso = this.solicitacao.value.numeroProcesso.replace('-', '').split('.').join('');

      return this.rest.get(`${URL_API.PATH_SOLICITACAO}/processo/buscar`, {
        numeroProcesso,
        tipoJustica: this.solicitacao.value.tipoDeJustica.toString()
      });

    }

    preencherVo() {
      return {
        id: null,
        username: new FormControl(null),
        dataHoraAbertura: null,
        nome: new FormControl({ value: null }, [Validators.required]),
        email: new FormControl({ value: null }, [Validators.required]),
        tipoDeJustica: new FormControl(null),
        numeroProcesso: new FormControl({ value: null, disabled: true }),
        comarca: new FormControl({ value: null, disabled: true }),
        vara: new FormControl({ value: null, disabled: true }),

        numeroINFOPEN: new FormControl(null),
        descricaoSolicitacao: new FormControl(null, [Validators.required, Validators.maxLength(5000)]),

        listaCartorio: [],
        municipio: new FormControl({ value: null }),
        cartorio: new FormControl({ value: null }),
        localidade: new FormControl({ value: null, disabled: true }),

        listaTipoProcesso: new FormControl([]),
        listaTipoProcessoCompleta: [],

        listaSistemas: new FormControl([]),
        listaSistemasCompleta: [],

        listaClassificacao: new FormControl([]),
        listaClassificacaoCompleta: [],

        assunto: new FormControl(null),
        assuntos: [],

        files: null,

        demandaRecebida: new FormControl(null)

      } as SolicitacaoVO;
    }

}
